import React, { useMemo } from "react";
import { Field } from "react-final-form";
import { TextInput } from "../../../../components/inputs/final_form/TextInput";
import { Switch } from "../../../../components/inputs/final_form/Switch";
import { LoadingButton } from "../../../../components/LoadingButton";
import { composeValidators, numericInRange, required } from "../../../../util/validators";
import { AdministrateSelectInput, AdminOptionableInput } from "../../../components/inputs/AdministrateSelectInput";

export const UiPathBotAutomationForm = ({ values, handleSubmit, submitting, automation }) => {
  const initialPayorOptions = useMemo(
    () => automation?.payors?.map((payor) => ({ label: payor.name, value: payor.id })) || [],
    [automation?.payors]
  );
  const initialCodeGroupOptions = useMemo(
    () => automation?.codeGroups?.map((codeGroup) => ({ value: codeGroup.id, label: codeGroup.name })) || [],
    [automation?.codeGroups]
  );
  const initialPortalOptions = useMemo(
    () =>
      automation?.benefitManagementPortal
        ? [{ value: automation?.benefitManagementPortal?.id, label: automation?.benefitManagementPortal?.name }]
        : [],
    [automation?.benefitManagementPortal]
  );

  return (
    <>
      <Field
        component={AdministrateSelectInput}
        resourceUrl="/admin/enums/automation_vendors.json"
        label="Vendor"
        name="vendor"
        valueKey="id"
        labelKey="label"
        searchParam="search"
        validate={required}
        required
      />

      <Field
        component={AdministrateSelectInput}
        resourceUrl="/admin/code_groups.json"
        label="Code Groups"
        labelKey="name"
        valueKey="id"
        initialOptions={initialCodeGroupOptions}
        isMulti
        name="codeGroupIds"
        validate={required}
        required
      />

      <Field
        component={AdminOptionableInput}
        resource="payors"
        searchParam="name"
        label="Payors"
        isMulti
        name="payorIds"
        validate={required}
        initialOptions={initialPayorOptions}
        required
      />

      <Field
        component={AdministrateSelectInput}
        resourceUrl="/admin/benefit_management_portals.json"
        label="Portal"
        name="benefitManagementPortalId"
        initialOptions={initialPortalOptions}
        searchParam="name"
        validate={required}
        required
      />

      <Field
        component={AdministrateSelectInput}
        resourceUrl="/admin/enums/ui_path_bot_types.json"
        label="Bot Type"
        name="uiPathBotType"
        valueKey="id"
        labelKey="label"
        searchParam="search"
        validate={required}
        required
      />

      {values.vendor === "uipath" && (
        <Field component={TextInput} validate={required} label="Folder Name" name="uiPathFolderName" required />
      )}
      <Field component={TextInput} validate={required} label="Automation Name" name="uiPathReleaseName" required />
      <Field
        component={TextInput}
        type="number"
        name="priority"
        label="Priority"
        validate={composeValidators(required, numericInRange(1, 10))}
        required
        min="1"
        max="10"
      />
      <Field type="checkbox" component={Switch} validate={required} label="Enabled?" name="enabled" required />

      <LoadingButton loading={submitting} onClick={handleSubmit} disabled={submitting}>
        Submit
      </LoadingButton>
    </>
  );
};
